export const CLIENT_CONFIG_RESPONSE = "CLIENT_CONFIG_RESPONSE"

export interface ClientConfigData {
    geicoAnalyticsUri: string;    
    configLoaded: boolean;
    geicoAppUrl: string;
    userType: string,
    adClientId: string,   
    isAutoRedirectEnabled: boolean;
    isMultiplePartnerRecommendationEnabled: boolean;
    isBusinessKeywordRecommendationEnabled: boolean;
    isRecallEnabled: boolean;
    isUniversalKeywordEnabled: boolean;
    adInstance: string;
    graphUrl: string;
    cauDisabledState: string[];
    isCombinedProductPageEnabled: boolean;
    radarApiKey: string;
    libertyMutualBondsCustomerId: string;
    libertyMutualBondsAccessCode: string;
    isCommercialLaunchpadExternalConfigurationEnabled: boolean;
    availableProductsCustomer?: string[];
    availableVendorsAgent?: Record<string, string[]>;
    redirectableVendorsAgent?: Record<string, string[]>;
    vendorLabelMap?: Record<string, string>;
}

export const defaultConfig: ClientConfigData = {
    geicoAnalyticsUri: "",   
    configLoaded: false,
    geicoAppUrl: "https://www.geico.com",    
    isAutoRedirectEnabled: false,
    isMultiplePartnerRecommendationEnabled: false,
    isBusinessKeywordRecommendationEnabled:false,
    isRecallEnabled: false,
    isUniversalKeywordEnabled: false,
    userType: "",
    adClientId: "",
    adInstance: "",
    graphUrl: "",
    cauDisabledState: [],
    isCombinedProductPageEnabled: false,
    radarApiKey: "",
    libertyMutualBondsCustomerId: "",
    libertyMutualBondsAccessCode: "",
    isCommercialLaunchpadExternalConfigurationEnabled: false,
    availableProductsCustomer: undefined,
    availableVendorsAgent: undefined,
    redirectableVendorsAgent: undefined,
    vendorLabelMap: undefined,
}


export interface ClientConfigResponse {
    type: typeof CLIENT_CONFIG_RESPONSE;
    data: ClientConfigData
}
